import React from 'react';
import { useParams } from 'react-router-dom';
import Page from 'components/Page';

export default function ErrorPage({
  errorMessage = 'Unknown Error',
  errorDescription = 'No description for this error',
  errorDetail = '',
  overrideType = null,
}) {
  const { type } = useParams<{ type: string }>();

  switch (overrideType || type) {
    case '403':
      errorMessage = 'Access Denied';
      errorDescription =
        'The resource that you are trying to access is only visible to Admins.';
      break;
    case '404':
      errorMessage = 'Page Not Found';
      errorDescription =
        'There is no resource at this URL, please use the back button in your browser.';
      break;
    case '501':
      errorMessage = 'API Error';
      errorDescription =
        'An invalid GraphQL query or mutation was submitted to the API';
      break;
    case '511':
      errorMessage = 'Authentication Error';
      errorDescription =
        'There was a problem verifying your session credentials. Please sign out and try again.';
  }

  return (
    <Page title={`Error ${type || ''}`}>
      <div className="p-6 pb-0 mt-6 text-red-700 bg-red-100 card">
        <aside className="font-semibold">{errorMessage}</aside>
        <main>
          <p>{errorDescription}</p>
          <p className="mt-6 text-sm leading-loose tracking-wide opacity-75">
            {errorDetail}
          </p>
        </main>
      </div>
    </Page>
  );
}
